import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/productDAT/page.tsx")